import React, { useEffect } from 'react'
import { useParams, useNavigate } from 'react-router-dom'
import { useDispatch, useSelector } from 'react-redux'
import { makeStyles } from '@material-ui/core'
import Card from '@material-ui/core/Card'
import {
  getUserExamQuestionsTemp,
  answerTemp,
  getUserExamAnswers,
  finishUserExamTemp,
  getExamQuestionsTemp,
  selectorFinishResult,
} from 'src/app/slices/examSlice'
import usePagination from 'src/hooks/usePagination'
import Description from './Description'
import Pagination from './Pagination'
import Questions from './Questions'

const useStyles = makeStyles(() => ({
  root: {
    borderRadius: 15,
    padding: '32px 20px 35px 20px',
  },

}))

export default function Exam({ isUser }) {
  const classes = useStyles()
  const dispatch = useDispatch()
  const navigate = useNavigate()

  console.log(navigate)

  const { userExamId } = useParams()
  const finishedResponse = useSelector(selectorFinishResult)
  const exam = useSelector((state) => state.exam.selectedExam.exam || {})
  const totalHits = useSelector((state) => state.exam.selectedExam.totalHits || 0)
  const answers = useSelector((state) => state.exam.selectedExam.answers)
  // const [first, after] = usePagination(40, 0)
  const [first, after] = usePagination(+userExamId === 99 ? 45 : 40, 0)

  useEffect(() => {
    if (isUser) dispatch(getUserExamQuestionsTemp({ after, first, userExamId }))
    else dispatch(getExamQuestionsTemp({ after, first, examId: userExamId }))
  }, [first, after])

  // useEffect(() => {
  //   if (isUser) dispatch(getUserExamAnswers({ userExamId, first: totalHits || 10, after: 0 }))
  // }, [totalHits, userExamId])

  // useEffect(() => {
  //   if (isUser) dispatch(getUserExamAnswers({ userExamId, first: totalHits || 10, after: 0 }))
  // }, [])

  useEffect(() => {
    if (isUser) dispatch(getUserExamAnswers({ userExamId, first: 1000, after: 0 }))
  }, [])

  const onSubmit = () => {
    dispatch(finishUserExamTemp(userExamId))
    if (finishedResponse?.data?.code === 200 || finishedResponse?.data?.success === true) {
      navigate('/app')
    } else {
      navigate('')
    }
  }
  if (exam.questions) {
    return (
      <Card elevation={0} xs={12} className={classes.root}>

        <Description data={exam} />

        <Pagination
          totalHits={totalHits}
          noPaginationNumber
        />

        <Questions
          userExamId={userExamId}
          after={after}
          handleSelectAnswer={(answer, params) => dispatch(answerTemp(answer, params))}
          data={exam.questions}
          answers={answers}
          totalHits={totalHits}
        />

        <Pagination
          totalHits={totalHits}
          withSubmit
          onSubmit={onSubmit}
        />

      </Card>
    )
  }
  return null
}
